export default __webpack_public_path__ + "static/media/star.36143648.svg";